import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EvaluationsRoutingModule, routes } from './evaluations-routing.module';
import { EvaluationDataComponent } from './evaluation-data/evaluation-data.component';
import { EvaluationHistoryComponent } from './evaluation-history/evaluation-history.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatExpansionModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { RequirementEvaluationComponent } from './requirement-evaluation/requirement-evaluation.component';
import { AuthGuard } from 'src/app/shared/services';

@NgModule({
  declarations: [EvaluationDataComponent, EvaluationHistoryComponent, RequirementEvaluationComponent],
  imports: [
    CommonModule,
    EvaluationsRoutingModule,
    SharedModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFontAwesomeModule,
    TranslateModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class EvaluationsModule { }
